import { Button, DialogContent, DialogFooter, DialogHeader, DialogTitle, Input } from '@ibsys/kit';
import { ArrowUpFromLine } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useSettingsStore } from '@/entities/settings';
import { DEFAULT_API_HOST } from '@/shared/lib';
import { IconButton } from '@/shared/ui';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const SettingsDialog: React.FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation(['auth']);
  const apiHost = useSettingsStore((s) => s.apiHost);
  const setApiHost = useSettingsStore((s) => s.setApiHost);
  const serviceToken = useSettingsStore((s) => s.serviceToken);
  const setServiceToken = useSettingsStore((s) => s.setServiceToken);

  const [apiUrlInput, setApiUrlInput] = useState('');
  const [serviceTokenInput, setServiceTokenInput] = useState('');

  // Синхронизируем поля при открытии диалога
  useEffect(() => {
    if (isOpen) {
      setApiUrlInput(apiHost ?? '');
      setServiceTokenInput(serviceToken ?? '');
    }
  }, [isOpen, apiHost, serviceToken]);

  const handleSave = () => {
    setApiHost(apiUrlInput);
    if (serviceTokenInput.trim()) {
      setServiceToken(serviceTokenInput.trim());
    } else {
      useSettingsStore.getState().clearServiceToken();
    }
    onClose();
    window.location.reload();
  };

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{t('settings')}</DialogTitle>
      </DialogHeader>
      <div className="flex flex-col gap-4 pt-2">
        <div className="grid gap-2">
          <Input
            id="auth-settings-api-url"
            type="url"
            label={t('apiUrl')}
            placeholder={DEFAULT_API_HOST || undefined}
            value={apiUrlInput}
            onChange={(e) => setApiUrlInput(e.target.value)}
          />
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm text-muted-foreground shrink-0">
            {`${t('defaultApiHost')}: ${DEFAULT_API_HOST}`}
          </span>
          <IconButton
            type="button"
            size="icon"
            className="shrink-0"
            label={t('useDefaultApiHost')}
            icon={<ArrowUpFromLine className="h-4 w-4" />}
            onClick={() => setApiUrlInput(DEFAULT_API_HOST)}
          />
        </div>
        <div className="grid gap-2">
          <Input
            id="auth-settings-service-token"
            type="password"
            label={t('serviceToken')}
            value={serviceTokenInput}
            onChange={(e) => setServiceTokenInput(e.target.value)}
          />
        </div>
      </div>
      <DialogFooter className="gap-2 justify-end">
        <Button type="button" variant="secondary" onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button type="button" onClick={handleSave}>
          {t('save')}
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};
